/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationPavillonInformationMutation from '../graphql/mutations/SaveSimulationPavillonInformationMutation.js';

export const useSaveSimulationPavillonInformationMutation = () => {
  return useCommitMutation(SaveSimulationPavillonInformationMutation, {
    dataProp: 'saveSimulationPavillonInformation_M_simulation_pavillon_information'
  });
};

export default useSaveSimulationPavillonInformationMutation;
